import Modal from "@visiblethread/react-components/dist/components/Modal";
import Button, {
  buttonVariants,
} from "@visiblethread/react-components/dist/components/Button";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { addToIgnoreList } from "slices/discovery/actions/actionButtons";
import { hideModal } from "slices/app/actions/modals";
import { modalTypes } from "constants/types";
import TwoOptionsRow from "components/TwoOptionsRow";
import { useState } from "react";

const IgnoreTermConfirm = ({ terms, term }) => {
  const dispatch = useDispatch();
  const [ignoreHoveredOnly, setIgnoreHoveredOnly] = useState(false);

  const handleIgnore = () => {
    dispatch(addToIgnoreList(ignoreHoveredOnly ? [term] : terms));
  };

  const handleCancel = () => {
    dispatch(hideModal(modalTypes.IGNORE_TERM_CONFIRM));
  };

  const getTermsList = () => {
    if (terms.length === 2) {
      return `"${terms[0]}" and "${terms[1]}"`;
    }
    return `"${terms[0]}", "${terms[1]}" and ${terms.length - 2} ${terms.length === 3 ? "other" : "others"}`;
  };

  return (
    <Modal
      show
      className="fade-in discovery_ignore_terms_confirm"
      backdrop="static"
      onDismiss={handleCancel}
      centered
    >
      <Modal.Header>
        <b>Confirm Ignore Action</b>
      </Modal.Header>
      <Modal.Body>
        <p>
          You have checked {terms.length} items: {getTermsList()}.
        </p>
        <TwoOptionsRow
          option1={`Ignore all ${terms.length} items`}
          option2={`Just ignore "${term}"`}
          state={ignoreHoveredOnly}
          setState={setIgnoreHoveredOnly}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant={buttonVariants.primary}
          onClick={handleIgnore}
          content="Ignore"
        />
        <Button
          variant={buttonVariants.secondary}
          onClick={handleCancel}
          content="Cancel"
        />
      </Modal.Footer>
    </Modal>
  );
};

export default IgnoreTermConfirm;

IgnoreTermConfirm.propTypes = {
  terms: PropTypes.arrayOf(PropTypes.string),
  term: PropTypes.string,
};
